import {Component} from "@angular/core";

@Component({
    selector: 'nm-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss']
})
export class AuthComponent {
}